<template>
  <div class="cmi-leicester">
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/cfmchurch_bg_011.jpg);"
      ></div>
      <div class="container">
        <h1><span class="title-span">CFM</span> LEICESTER</h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/toronto">Leicester</router-link></li>
        </ul>
      </div>
    </div>
    <section>
      <div class="cmi-event-local">
        <alert-view :baseUrl="'Leicester/Home/'"></alert-view>
        <event-view :baseUrl="'Leicester/Home/'"></event-view>
      </div>
    </section>
    <section>
      <div class="cmi-section">
        <resource-view :baseUrl="'Leicester/Home/'"></resource-view>
      </div>
    </section>
    <section>
      <div class="cmi-leaders">
        <person-view :baseUrl="'Leicester/Home/'"></person-view>
      </div>
    </section>

    <section>
      <div class="block">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2">
              <contact></contact>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div
        class="googlemap"
        data-latlng="52.626729, -1.138785"
        data-scrollwheel="false"
        data-icon="dist/assets/images/map_marker.png"
        data-zoom="17"
        data-theme="Default"
      >
        <div class="marker-content">
          <h4>CMI LEICESTER</h4>
          <p>
            87 Clarendon Street<br />
            LE2 7FH<br />
            Leicester<br />
            United Kingdom
          </p>
        </div>
      </div>
    </section>
    <footer-leicester></footer-leicester>
  </div>
</template>
<script>
export default {
  components: {
    Contact: () => import("./Contact"),
    AlertView: () => import("./AlertView"),
    ResourceView: () => import("./ResourceView"),
    EventView: () => import("./EventView"),
    PersonView: () => import("./PersonView"),
    FooterLeicester: () => import("./FooterLeicester")
  },
  data() {
    return {};
  },
  mounted() {
    window.initMap();
  }
};
</script>
